import {
  Acknowledgement,
  AcknowledgementStatus,
} from "components/timesheet/acknowledgement";
import { AddLog, AddLogButton } from "components/timesheet/add-log";
import { HeaderDescription, HeaderTitle } from "components/timesheet/header";
import {
  TimesheetEntries,
  TimesheetLoading,
  TimesheetRoot,
} from "components/timesheet/timesheet";

import AcknowledgmentDialog from "@/modules/timesheet/logs/components/acknowledgement-dialog";
import AddLogCard from "components/timesheet/card/add-log";
import { Badge } from "ui/components/badge";
import EntryCard from "components/timesheet/card/entry";
import { LogByDayLoader } from "@/modules/timesheet/logs/views/week/loader";
import { TIMESHEET_LOG_DAY_VIEW } from "@/lib/utils";
import { TimesheetLogProvider } from "components/timesheet/context/log";
import { cn } from "utils";
import { useAcknowledgementMutation } from "components/timesheet/acknowledgement/mutation";
import { useState } from "react";
import { eventBus } from "utils/eventBus";

export default function TimesheetLogByDay({ date }) {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const acknowledgementMutation = useAcknowledgementMutation();

  const handleAcknowledgeCreation = () => {
    acknowledgementMutation.mutate(date, {
      onSuccess: () => {
        setShowConfirmDialog(false);
        eventBus.emit("refresh", `timesheet-${date}`);
      },
      onError: () => {
        // Error is already handled in the mutation hook
        setShowConfirmDialog(false);
      },
    });
  };

  return (
    <>
      <TimesheetLogProvider date={date}>
        <TimesheetLoading>
          <LogByDayLoader />
        </TimesheetLoading>
        <TimesheetRoot>
          <div className="lg:pt-6 pt-4">
            <div className="flex flex-col gap-6 lg:px-6 px-4">
              <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
                <div>
                  <div className="flex items-center">
                    <HeaderTitle className="text-xl font-semibold " />
                    <Acknowledgement>
                      {({ isAcknowledged, totalLogsInADay }) => (
                        <Badge
                          className={cn(
                            "ml-2",
                            isAcknowledged
                              ? "bg-secondary text-secondary-foreground"
                              : "bg-red-50 text-red-900 border-none"
                          )}
                        >
                          {totalLogsInADay} Hour{totalLogsInADay > 1 ? "s" : ""}
                        </Badge>
                      )}
                    </Acknowledgement>
                    <AcknowledgementStatus className="text-gray-500 size-4.5 ml-2" />
                  </div>
                  <HeaderDescription className="text-sm text-muted-foreground mt-1" />
                </div>
              </div>
            </div>
            <div className="mt-4 pl-4 lg:pl-6 flex gap-4.5 overflow-x-auto no-scrollbar py-1">
              <TimesheetEntries>
                {({ entry }) => (
                  <EntryCard
                    key={entry.id}
                    entry={entry}
                    href={`/${TIMESHEET_LOG_DAY_VIEW}/${entry.id}`}
                  />
                )}
              </TimesheetEntries>
              <AddLog>
                {({ date }) => (
                  <AddLogCard href={`/timesheet/logs/+?date=${date}`} />
                )}
              </AddLog>
              <Acknowledgement
                onAcknowledge={() => setShowConfirmDialog(true)}
              />
            </div>
          </div>
        </TimesheetRoot>
      </TimesheetLogProvider>
      <AcknowledgmentDialog
        open={showConfirmDialog}
        onOpenChange={setShowConfirmDialog}
        onConfirm={handleAcknowledgeCreation}
        isLoading={acknowledgementMutation.isPending}
      />
    </>
  );
}
